import React from "react";
import InternalLoadLink from "../components/Library/InternalLoadLink";
import { ENTITY_TYPE } from "../config/constants";
import { isInternalURL } from "./utils";

export var entityToHTML = function entityToHTML(story, styles) {
  return function (entity, originalText) {
    if (entity.type.toLowerCase() === ENTITY_TYPE.LINK) {
      var matches = isInternalURL(entity.data.url);
      if (matches && matches.length > 1) {
        return React.createElement(InternalLoadLink, {
          name: originalText,
          href: entity.data.url,
          identifier: matches[1] + "-" + story.id,
          className: styles.link });
      }
      return React.createElement("a", { href: entity.data.url, className: styles.link });
    }
    return originalText;
  };
};


// WEBPACK FOOTER //
// ./src/utils/entityToHTML.js